module.exports = __webpack_public_path__ + "img/american-credit-home-slide-11.5515b38.webp";